import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { DEFAULT_THEME } from '@constants/constants';
import styles from './ProductSpecialist.module.scss';

export interface IProductSpecialist {
  productSpecialist?: {
    title: string;
    text: string;
    name: string;
    image: string;
    email: string;
    emailText: string;
    phone: string;
    sectors: {
      name: string;
      email: string;
      phone: [];
    }[];
  };
  sector?: string;
}

export const ProductSpecialist = ({ productSpecialist, sector = DEFAULT_THEME }: IProductSpecialist) => {
  const [specialist, setSpecialist] = useState(productSpecialist);

  useEffect(() => {
    if (productSpecialist !== specialist) {
      setSpecialist(productSpecialist);
    }
  }, [specialist, productSpecialist]);
  if (!specialist) {
    return null;
  }

  const { email = '', phone = '' } =
    specialist.sectors.find((currentSector) =>
      currentSector.name === sector
        ? {
            phone: currentSector.phone,
            email: currentSector.email
          }
        : null
    ) ?? specialist.sectors[0];

  return (
    <Card className={styles.ProductSpecialist}>
      <Card.Body>
        <Card.Title className={styles.title}>{specialist.title}</Card.Title>
        <Card.Text className={styles.text}>
          {specialist.text} <b>{specialist.name}</b>.
        </Card.Text>
      </Card.Body>
      <Card.Footer className={styles.footer}>
        <Row>
          <Col className="pl-0">
            <Image height={155} width={155} priority={true} className="mr-3" src={specialist.image} alt="?" />
          </Col>
          <Col className="mt-5">
            <Row className={styles.name}>{specialist.name}</Row>
            <Row className={styles.link}>
              <FontAwesomeIcon icon={faEnvelope} className={`mr-2 ${styles.icon}`} />
              <a href={`mailto:${email}`}>{specialist.emailText}</a>
            </Row>
            <Row className={styles.link}>
              <FontAwesomeIcon icon={faPhone} className={`mr-2 ${styles.icon}`} />
              <a href={`tel:${phone}`}>{phone}</a>
            </Row>
          </Col>
        </Row>
      </Card.Footer>
    </Card>
  );
};
